import { getMetadata } from "../../onchain/index.js";
function constructMetadata(data) {
  if ("accessId" in data) {
    const metadata2 = {
      _newAccessId: data.accessId
    };
    return {
      _metadata: metadata2
    };
  }
  const metadata = {
    _trackingId: data.trackingId
  };
  if (data.currentAccessId) {
    metadata._currentAccessId = data.currentAccessId;
  }
  if (data.historyLink) {
    metadata._historyLink = data.historyLink;
  }
  metadata._historyOrder = getMetadata().historyOrder + 1;
  return {
    _metadata: metadata
  };
}
export {
  constructMetadata
};
//# sourceMappingURL=constructMetadata.js.map